import moment from 'moment'

/** Canonical UI/PDF calendar date: "21 Jul 2026" */
export const DISPLAY_DATE_FORMAT = 'D MMM YYYY'

const PARSE_FORMATS = ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY', moment.ISO_8601]

/**
 * Format a date for display across the app (lists, previews, etc.).
 * @param {string|Date|number|null|undefined} val
 * @param {string} [fallback='—']
 * @returns {string}
 */
export function formatDisplayDate (val, fallback = '—') {
  if (val == null || val === '') return fallback
  const s = String(val).trim()
  if (!s) return fallback

  const isoPrefix = /^(\d{4}-\d{2}-\d{2})/.exec(s)
  if (isoPrefix) {
    const m = moment(isoPrefix[1], 'YYYY-MM-DD', true)
    if (m.isValid()) return m.format(DISPLAY_DATE_FORMAT)
  }

  const strict = moment(s, PARSE_FORMATS, true)
  if (strict.isValid()) return strict.format(DISPLAY_DATE_FORMAT)

  const loose = moment(val)
  return loose.isValid() ? loose.format(DISPLAY_DATE_FORMAT) : fallback
}
